import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import * as E from '../../app.enums';
import { UtilsService } from '../utils/utils.service';


@Injectable({
  providedIn: 'root'
})
export class BrowserSelectorService {
  /*
    This code is based on https://github.com/verbatim/css_browser_selector/blob/master/css_browser_selector.js
 */
  private userAgent: string;
  isCssClassesAdded: boolean = false;

  constructor(@Inject(DOCUMENT) private document: any, private utilsService: UtilsService) {
    this.userAgent = navigator.userAgent;
  }

  private is(testString: string): boolean {
    return RegExp(testString, 'i').test(this.userAgent);
  }

  getIsCssClassesAdded() {
    return this.isCssClassesAdded;
  }

  private extractVersion(p: string, n: string): string {
    n = n.replace('.', '_');
    let i = n.indexOf('_');
    let ver = '';
    while (i > 0) {
      ver += ` ${p}${n.substring(0, i)}`;
      i = n.indexOf('_', i + 1);
    }

    ver += ` ${p}${n}`;

    return ver;
  }

  getSource(): number {
    if (this.isMobile()) {
      return E.Source.MobileWeb;
    } else if (this.isTablet()) {
      return E.Source.TabletWeb;
    }
    return E.Source.DesktopWeb;
  }

  public isIPadPro(): boolean {
    let isIPadPro = false;
    if (navigator.userAgent.indexOf('Macintosh') > -1) {
      try {
        document.createEvent('TouchEvent');
        isIPadPro = true;
      } catch (e) { }
    }
    return isIPadPro;
  }
  public isTablet(): boolean {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    let isIPadPro = false;
    if (navigator.userAgent.indexOf('Macintosh') > -1) {
      try {
        document.createEvent('TouchEvent');
        isIPadPro = true;
      } catch (e) { }
    }
    return (check || isIPadPro) && !this.isMobile();
  }

  public isMobile(): boolean {
    /* tslint:disable:max-line-length */
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) { check = true; } })(navigator.userAgent || navigator.vendor);
    return check;
  }

  setBrowserCssClasses(isRegistered = false): void {
    if (!this.document || !this.document.body) {
      return;
    }

    const uaInfo = {},
      screens = [320, 480, 640, 768, 1024, 1152, 1280, 1440, 1680, 1920, 2560],
      allScreens = screens.length,
      ua = this.userAgent.toLowerCase(),
      g = 'gecko',
      w = 'webkit',
      c = 'chrome',
      f = 'firefox',
      s = 'safari',
      o = 'opera',
      m = 'mobile',
      t = 'tablet',
      a = 'android',
      bb = 'blackberry',
      lang = 'lang_',
      dv = 'device_',

      cssClasses = [
        // browser
        ((!(/opera|webtv/i.test(ua)) && /msie\s(\d+)/.test(ua)
          || (/trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.test(ua)))) ?
          ('ie ie' + (/trident\/4\.0/.test(ua) ? '8' : RegExp.$1 === '11.0' ? '11' : RegExp.$1))
          : this.is('firefox/') ? g + ' ' + f +
            (/firefox\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? ' ' + f + RegExp.$2 + ' ' + f + RegExp.$2 + '_' + RegExp.$4 : '')
            : this.is('gecko/') ? g
              : this.is('opera') ? o +
                (/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? ' ' + o + RegExp.$2 + ' ' + o + RegExp.$2 + '_' + RegExp.$4 :
                  (/opera(\s|\/)(\d+)\.(\d+)/.test(ua) ? ' ' + o + RegExp.$2 + ' ' + o + RegExp.$2 + '_' + RegExp.$3 : ''))
                : this.is('konqueror') ? 'konqueror'

                  : this.is('blackberry') ?
                    (bb +
                      (/Version\/(\d+)(\.(\d+)+)/i.test(ua)
                        ? ' ' + bb + RegExp.$1 + ' ' + bb + RegExp.$1 + RegExp.$2.replace('.', '_')
                        : (/Blackberry ? (([0-9]+)([a-z]?))[\/|;]/gi.test(ua)
                          ? ' ' + bb + RegExp.$2 + (RegExp.$3 ? ' ' + bb + RegExp.$2 + RegExp.$3 : '')
                          : '')
                      )
                    ) // blackberry

                    : this.is('android') ?
                      (a +
                        (/Version\/(\d+)(\.(\d+))+/i.test(ua)
                          ? ' ' + a + RegExp.$1 + ' ' + a + RegExp.$1 + RegExp.$2.replace('.', '_')
                          : '')
                        + (/Android (.+); (.+) Build/i.test(ua)
                          ? ' ' + dv + ((RegExp.$2).replace(/ /g, '_')).replace(/-/g, '_')
                          : '')
                      ) // android

                      : this.is('chrome') ? w + ' ' + c +
                        (/chrome\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? ' ' + c + RegExp.$2 +
                          ((<any>RegExp.$4 > 0) ? ' ' + c + RegExp.$2 + '_' + RegExp.$4 : '') : '')

                        : this.is('iron') ? w + ' iron'

                          : this.is('applewebkit/') ?
                            (w + ' ' + s +
                              (/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua)
                                ? ' ' + s + RegExp.$2 + ' ' + s + RegExp.$2 + RegExp.$3.replace('.', '_')
                                : (/ Safari\/(\d+)/i.test(ua)
                                  ?
                                  ((RegExp.$1 === '419' || RegExp.$1 === '417' || RegExp.$1 === '416' || RegExp.$1 === '412') ? ' ' + s + '2_0'
                                    : RegExp.$1 === '312' ? ' ' + s + '1_3'
                                      : RegExp.$1 === '125' ? ' ' + s + '1_2'
                                        : RegExp.$1 === '85' ? ' ' + s + '1_0'
                                          : '')
                                  : '')
                              )
                            ) // applewebkit

                            : this.is('mozilla/') ? g : ''

        // mobile
        , this.is('android|mobi|mobile|j2me|iphone|ipod|ipad|blackberry|playbook|kindle|silk') ? (this.isTablet() ? t : m) : ''

        // os/platform
        , this.is('j2me') ? 'j2me'
          : this.is('ipad|ipod|iphone') ?
            (
              (
                /CPU( iPhone)? OS (\d+[_|\.]\d+([_|\.]\d+)*)/i.test(ua) ?
                  'ios' + this.extractVersion('ios', RegExp.$2) : ''
              ) + ' ' + (/(ip(ad|od|hone))/gi.test(ua) ? RegExp.$1 : '')
            ) // iphone

            : this.is('playbook') ? 'playbook'
              : this.is('kindle|silk') ? 'kindle'
                : this.is('playbook') ? 'playbook'
                  : this.is('mac') ? 'mac' +
                    (/mac os x ((\d+)[.|_](\d+))/.test(ua) ? (' mac' + (RegExp.$2) + ' mac' + (RegExp.$1).replace('.', '_')) : '')
                    : this.is('win') ? 'win' +
                      (this.is('windows nt 10.0') ? ' win10'
                        : this.is('windows nt 6.2') ? ' win8'
                          : this.is('windows nt 6.1') ? ' win7'
                            : this.is('windows nt 6.0') ? ' vista'
                              : this.is('windows nt 5.2') || this.is('windows nt 5.1') ? ' win_xp'
                                : this.is('windows nt 5.0') ? ' win_2k'
                                  : this.is('windows nt 4.0') || this.is('WinNT4.0') ? ' win_nt'
                                    : ''
                      )
                      : this.is('freebsd') ? 'freebsd'
                        : (this.is('x11|linux')) ? 'linux'
                          : ''

        // user agent language
        , (/[; |\[](([a-z]{2})(\-[a-z]{2})?)[)|;|\]]/i.test(ua)) ?
          (lang + RegExp.$2).replace('-', '_') + (RegExp.$3 !== '' ? (' ' + lang + RegExp.$1).replace('-', '_') : '') : ''

        // beta: test if running iPad app
        , (this.is('ipad|iphone|ipod') && !this.is('safari')) ? 'ipad_app' : ''
        , this.isIPadPro() ? 'tablet ipad ipadPro' : ''
        , this.is('Edg') ? 'Edg' : ''
      ];

    if (this.utilsService.isKioskMode()) {
      cssClasses.push('inKiosk');
    }


    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(<any>window).MSStream;

    // Get the device pixel ratio
    const ratio = window.devicePixelRatio || 1;

    // Define the users device screen dimensions
    const screen = {
      width: window.screen.width * ratio,
      height: window.screen.height * ratio
    };

    // iPhone X Detection
    if (iOS) {
      if (screen.width === 1125 && screen.height === 2436) {
        cssClasses.push('iphoneX');
      } else {
        const iphone4 = (window.screen.height === 480);
        const iphone5 = (window.screen.height === 568);

        if (iphone4) {
          cssClasses.push('iphone4');
        }
        if (iphone5) {
          cssClasses.push('iphone5');
        }
      }
    }

    if (isRegistered) {
      cssClasses.push('registered-site');
    }

    this.document.body.className = cssClasses.join(' ').replace(/^ /, '').replace(/ +/g, ' ');
    this.isCssClassesAdded = true;
  }
}
